import SongDetails from './SongDetails';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { Col, Row } from 'antd';
import { ListIcon, Pause, Play } from '../../../Icons';
import { useEffect, useMemo, useState } from 'react';
import tinycolor from 'tinycolor2';
import { getImageAnalysis2 } from '../../../../utils/imageAnyliser';
import { uiActions } from '../../../../store/slices/ui';
import { AddSongToLibraryButton } from '../../../Actions/AddSongToLibrary';
import { spotifyActions } from '../../../../store/slices/spotify';
import { usePlayback } from '../../../../contexts/PlaybackContext';

const NowPlayingBarMobile = () => {
  const dispatch = useAppDispatch();
  const { playerState, isPlaying, pauseTrack, resumeTrack } = usePlayback();
  const currentSong = playerState?.track_window.current_track ?? null;
  const position = playerState?.position ?? 0;
  const duration = playerState?.duration ?? 1;
  const liked = useAppSelector((state) => state.spotify.liked);
  const [currentColor, setColor] = useState('blue');

  const progressPercent = useMemo(() => {
    if (!duration) return 0;
    return Math.min(Math.max((position / duration) * 100, 0), 100);
  }, [position, duration]);

  useEffect(() => {
    if (currentSong?.album?.images?.[0]?.url) {
      getImageAnalysis2(currentSong.album.images[0].url).then((r) => {
        let color = tinycolor(r);
        while (color.isLight()) {
          color = color.darken(10);
        }
        setColor(color.toHexString());
      });
    } else {
      setColor('blue');
    }
  }, [currentSong]);

  if (!currentSong) return <div></div>;

  return (
    <div>
      <div
        className='mobile-player'
        style={{ background: `linear-gradient(${currentColor} -50%, rgb(18, 18, 18) 300%)` }}
      >
        <Row justify='space-between'>
          <Col>
            <SongDetails isMobile />
          </Col>
          <Col style={{ display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                minWidth: 50,
                marginRight: 5,
                gap: 15,
                justifyContent: 'space-between',
              }}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(uiActions.toggleQueue());
                }}
              >
                <ListIcon />
              </button>
              {currentSong?.id ? (
                <AddSongToLibraryButton
                  size={17}
                  isSaved={liked}
                  id={currentSong.id}
                  onToggle={() => {
                    dispatch(spotifyActions.setLiked({ liked: !liked }));
                  }}
                />
              ) : null}
              <button
                onClick={() => {
                  if (isPlaying) {
                    pauseTrack().catch(() => {});
                  } else {
                    resumeTrack().catch(() => {});
                  }
                }}
              >
                {isPlaying ? <Pause /> : <Play />}
              </button>
            </div>
          </Col>
        </Row>
        <div className='time-line'>
          <div
            className='current-time'
            style={{
              width: `${progressPercent}%`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default NowPlayingBarMobile;
